import Breadcrumb from "components/Common/Breadcrumb2"
import toast from "components/Toast/Toast"
import useIsDarkTheme from "hooks/useIsDarkTheme"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import { withTranslation } from "react-i18next"
import { Link, useHistory, useParams } from "react-router-dom"
import Select from "react-select"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"
import { getAllWithStatusMapping } from "services/shipping-companies/calls"
import {
  createShippingEvent,
  deleteShippingEvent,
  getStatus,
  restoreShippingEvent,
} from "services/shipping-events/calls"
import "simplebar-react/dist/simplebar.min.css"

const { SearchBar } = Search

const Eventos = props => {
  document.title = "Eventos | Sensetek"

  const { t } = props

  const { id } = useParams()

  const [isLoading, setLoading] = useState(true)
  const [eventsCompany, setEventsCompany] = useState([])

  const [statuses, setStatuses] = useState()
  const [novoEvento, setNovoEvento] = useState({
    name: "",
    code: "",
    status: null,
  })

  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)

  const history = useHistory()

  const initPageOptions = {
    sizePerPage: 20,
    totalSize: 0,
    custom: true,
    showTotal: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    prePageText: "Anterior",
    nextPageText: "Próximo",
    paginationTotalRenderer: (from, to, size) => {
      return (
        <div className="d-inline">
          <span className="react-bootstrap-table-pagination-total">
            Registros Retornados: {size}
          </span>
        </div>
      )
    },
  }

  const [pageOptions, setPageOptions] = useState(initPageOptions)

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const columns = [
    {
      dataField: "externalEventId",
      text: "Cód. Evento",
      sort: true,
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "eventName",
      text: "Evento",
      sort: false,
      formatter: (cellContent, row) => cellContent || 0,
    },
    {
      dataField: "statusId",
      text: "Cód. Status",
      sort: false,
      formatter: (cellContent, row) => cellContent || 0,
    },
    {
      dataField: "statusName",
      text: "Status",
      sort: false,
      formatter: (cellContent, row) => cellContent || "-",
    },
    {
      dataField: "options",
      isDummyField: true,
      text: "Opções",
      align: "center",
      headerAlign: "center",
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <Link
              to="#"
              className={`btn btn-sm btn-${isDarkTheme ? "soft-" : ""}info`}
              onClick={() => {
                history.push(
                  `/configuracoes/params/transportadoras/${id}/editar/${row.eventId}`
                )
              }}
            >
              <i className="mdi mdi-pencil-outline" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Editar
              </UncontrolledTooltip>
            </Link>
          </li>
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-${
                row.deletedAt ? "secondary" : "danger"
              }`}
              onClick={async () => {
                if (row.deletedAt) {
                  try {
                    setLoading(true)
                    await restoreShippingEvent(row.eventId)
                    fetchAllShippingCompanyEvents()
                    fetchStatuses()
                    toast("success", "Evento ativado com sucesso!")
                  } catch (error) {
                    toast("warning", "Falha ao ativar Evento.")
                    console.log(error)
                  } finally {
                    setLoading(false)
                  }
                } else {
                  setConfirm({
                    title: "Confirmação",
                    body: (
                      <div>
                        <p>Esta ação ira desabilitar esta opção de Evento.</p>
                        <p>
                          Por favor, confirme se tem certeza que deseja
                          desabilitar este Evento?
                        </p>
                      </div>
                    ),
                    onConfirm: async () => {
                      setLoading(true)
                      try {
                        await deleteShippingEvent(row.eventId)
                        fetchAllShippingCompanyEvents()
                        fetchStatuses()
                        toast("success", "Evento desativado com sucesso!")
                      } catch (error) {
                        toast("warning", "Falha ao desativar Evento.")
                        console.log(error)
                      } finally {
                        setLoading(false)
                      }
                    },
                  })
                  setShowConfirm(true)
                }
              }}
            >
              <i
                className={`mdi mdi-${
                  row.deletedAt ? "account-reactivate" : "delete-forever"
                }`}
                id={`delToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`delToolTip${row.id}`}>
              {`${row.deletedAt ? "Reativar" : "Desativar"}`}
            </UncontrolledTooltip>
          </li>
        </ul>
      ),
    },
  ]

  useEffect(() => {
    try {
      fetchAllShippingCompanyEvents()
      fetchStatuses()
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }, [])

  const fetchAllShippingCompanyEvents = async () => {
    setLoading(true)
    try {
      const { payload } = await getAllWithStatusMapping(id)
      setPageOptions(old => {
        return { ...old, totalSize: payload?.length }
      })
      setEventsCompany(payload)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchStatuses = async () => {
    setLoading(true)
    try {
      const status = await getStatus()
      setStatuses(status)
    } catch {
      console.error(error)
    }
  }

  const statusesOptions = statuses?.map(s => {
    return { label: s.name, value: s.id }
  })

  const handleSubmit = async e => {
    e.preventDefault()
    if (novoEvento.name === "") {
      toast("warning", "Não é possível cadastrar um evento sem nome.")
      return
    }
    if (novoEvento.code === "") {
      toast("warning", "Não é possível cadastrar um evento sem código.")
      return
    }
    if (novoEvento.status === null) {
      toast(
        "warning",
        "Não é possível cadastrar um evento sem vinculá-lo a um status."
      )
      return
    }
    try {
      setLoading(true)
      await createShippingEvent({
        eventName: novoEvento.name,
        companyId: id,
        eventId: novoEvento.code,
        statusId: novoEvento.status.value,
      })
      toast("success", "Evento criado com sucesso!")
      fetchAllShippingCompanyEvents()
    } catch (error) {
      toast("warning", "Falha ao criar Evento.")
      console.error(error)
    } finally {
      setLoading(false)
    }
    setNovoEvento({
      name: "",
      code: "",
      status: null,
    })
  }

  const isDarkTheme = useIsDarkTheme()

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Eventos"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0 border-bottom">
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {t("Adicionar")}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <Label>{t("Nome do Evento")}</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Nome"
                            disabled={isLoading}
                            value={novoEvento.name}
                            onChange={e => {
                              setNovoEvento(old => {
                                return { ...old, name: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={2}>
                        <FormGroup>
                          <Label>{t("Código do Evento")}</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Código"
                            disabled={isLoading}
                            value={novoEvento.code}
                            onChange={e => {
                              setNovoEvento(old => {
                                return { ...old, code: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={3}>
                        <FormGroup>
                          <Label>Status</Label>
                          <Select
                            classNamePrefix="reactSelect"
                            options={statusesOptions}
                            placeholder="Status"
                            value={novoEvento.status}
                            onChange={e => {
                              setNovoEvento(old => {
                                return { ...old, status: e }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-end">
                        <FormGroup>
                          <Button type="submit">{t("Adicionar")}</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {`Eventos${
                    eventsCompany.length > 0
                      ? ` da transportadora: ${eventsCompany[0].company}`
                      : ""
                  }`}
                </CardHeader>
                <CardBody>
                  {isLoading && (
                    <div className="mt-3" style={{ textAlign: "center" }}>
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                  {!isLoading && (
                    <Row>
                      <Col>
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="eventId"
                          columns={columns}
                          data={eventsCompany}
                        >
                          {({ paginationTableProps, paginationProps }) => (
                            <ToolkitProvider
                              keyField="eventId"
                              columns={columns}
                              columnToggle
                              data={eventsCompany}
                              search
                            >
                              {toolkitProps => (
                                <React.Fragment>
                                  <Row>
                                    <SearchBar
                                      {...toolkitProps.searchProps}
                                      placeholder="Pesquisar"
                                    />
                                    <hr />
                                  </Row>

                                  <Row>
                                    <Col xl="12">
                                      <div className="table-responsive">
                                        <BootstrapTable
                                          keyField={"eventId"}
                                          responsive
                                          bordered={true}
                                          striped={true}
                                          defaultSorted={defaultSorted}
                                          selectRow={selectRow}
                                          classes={
                                            "table align-middle table-nowrap"
                                          }
                                          headerWrapperClasses={"thead-light"}
                                          {...toolkitProps.baseProps}
                                          {...paginationTableProps}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </Col>
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={async () => {
              await confirm?.onConfirm()
              setShowConfirm(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

Eventos.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Eventos)
